<template>
  <div class="main-cont-item">
    <div class="flex flex-justify-between flex-align-center">
      <h2 class="title-text">选择付款方式</h2>
      <el-radio-group v-model="channelCodeVal" @change="channelCodeChange" :size="formSize">
        <template v-for="(item, index) in paymentInfoNewList">
          <el-radio-button :label="item.channelCode" :key="index">
            <icon-svg :name="`icon-${item.channelCode}`" />
            {{item.channelName}}
          </el-radio-button>
        </template>
      </el-radio-group>
    </div>
    <el-form-item prop="channelCode" class="channel-code">
      <el-form-item prop="paymentChannelNo" class="payment-channel" v-loading="loading">
        <el-row>
          <div class="search-box" v-if="isSearch">
            <el-input v-model="searchVal" placeholder="请输入服务商名称或编号搜索" :size="formSize" @input="searchValChange"></el-input>
          </div>
          <el-radio-group class="group-list" v-model="paymentChannelNo" @change="paymentChannelChange">
            <el-col
              :span="24"
              class="margin-bottom-16"
              v-for="(item, index) in searchPaymentInfoList"
              :key="index"
            >
              <el-radio
                :label="item.paymentChannelNo"
                :disabled="setRadioDisabled(item)"
                @mouseenter.native="handleMouseEnter(item)"
                @mouseleave.native="handleMouseLeave()"
              >
                <el-row>
                  <el-col :span="12">
                    {{item.paymentChannelName || '-'}}
                  </el-col>
                  <el-col :span="12">
                    <span>
                      余额:
                      <i class="el-icon-loading" v-if="isRealTimeBalanceLoading && isLoadingIndex === index"></i>
                      <span v-else>¥{{item.usableAmount | toFenThousandsAndFloat}}</span>
                    </span>
                    <el-link
                      type="primary"
                      @click="handleManualQuery(item, index)"
                      v-if="paymentChannelNo === item.paymentChannelNo || mousePaymentNo === item.paymentChannelNo"
                      style="margin-left: 10px;"
                    >
                      手动查询
                    </el-link>
                  </el-col>
                </el-row>
              </el-radio>
            </el-col>
          </el-radio-group>
        </el-row>
        <el-button type="text" @click="selectOther" class="text-btn" v-if="!isSearch && !loading">
          选择其他渠道<i class="el-icon-arrow-down" style="margin-left: 8px"></i>
        </el-button>
      </el-form-item>
    </el-form-item>
    <el-form-item
      label="短信验证码"
      prop="code"
      v-if="[1, '1'].includes(payMethodObj.needCode)"
    >
      <div class="flex">
        <el-input
          v-model.trim="codeVal"
          placeholder="请输入短信验证码"
          v-number-only:0="codeVal"
          maxlength="6"
          style="width: 140px"
        />
        <div class="payment-code-tip">
          <el-button
            v-if="timeStr===0"
            :size="formSize"
            type="text"
            @click="getVaildPaySellerSmsCode"
          >获取验证码</el-button>
          <div v-else style="margin-left: 8px">倒计时{{timeStr}}s</div>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import { setPaymentPaymentSendPayCode, getRealTimeBalance } from '@/api/receivables';
import { getRefundSendPayCode } from '@/api/refund';

export default {
  props: {
    paymentInfoNewList: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    paymentObj: {
      type: Object,
      default: () => ({}),
    },
    payMethodObj: {
      type: Object,
      default: () => ({}),
    },
    code: {
      type: [Number, String],
      default: '',
    },
    channelCode: {
      type: String,
      default: '',
    },
    // 验证码类型，1是付款，2是退款
    payCodeType: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      isSearch: false,
      searchVal: '',
      paymentInfoList: [],
      searchPaymentInfoList: [],
      paymentChannelNo: '',
      /** ---定时器--- */
      timeStr: 0,
      timer: null,
      isSmsFlag: false,
      defaultPayeeBusinessList: [], // 默认的服务商数据
      isRealTimeBalanceLoading: false, // 手动查询loading
      isLoadingIndex: -1, // 手动查询loading索引
      mousePaymentNo: '', // 鼠标移入paymentChannelNo值
    };
  },
  computed: {
    codeVal: {
      get() {
        return this.code;
      },
      set(val) {
        this.$emit('update:code', val);
      },
    },
    channelCodeVal: {
      get() {
        return this.channelCode;
      },
      set(val) {
        this.$emit('update:channelCode', val);
      },
    },
  },
  methods: {

    handleMouseEnter(row) {
      // 鼠标移入时的逻辑
      this.mousePaymentNo = row.paymentChannelNo || '';
    },
    handleMouseLeave() {
      // 鼠标移出时的逻辑
      this.mousePaymentNo = '';
    },
    // 手动查询操作
    async handleManualQuery(row, rowIndex) {
      try {
        const params = {
          channelNo: row.channelNo, // 渠道号
          paymentChannelNum: row.paymentChannelNum, // 商户号
        };
        this.isRealTimeBalanceLoading = true;
        this.isLoadingIndex = rowIndex;
        const { data } = await getRealTimeBalance(params);
        this.searchPaymentInfoList = (this.searchPaymentInfoList || []).map((item, index) => {
          if (index === rowIndex) {
            item.usableAmount = data?.usableAmount || '';
          }
          return item;
        });
        this.isLoadingIndex = -1;
        this.isRealTimeBalanceLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoadingIndex = -1;
        this.isRealTimeBalanceLoading = false;
      }
    },
    // 清除定时器
    clearInterval() {
      this.timeStr = 0;
      window.clearInterval(this.timer);
      this.timer = null;
    },
    paymentChannelChange(val) {
      const { paymentChannelName = '', channelNo = '', payeeBusinessNo = '' } = (this.paymentInfoList.filter((it) => it.paymentChannelNo === val))[0];
      this.$emit('paymentChannelChange', { paymentChannelNo: val, paymentChannelName, channelNo, payeeBusinessNo });
    },
    // 付款渠道选择
    channelCodeChange(val) {
      this.$nextTick(() => {
        const { paymentInfo = [] } = this.paymentInfoNewList.length ? (this.paymentInfoNewList.filter((it) => it.channelCode === val))[0] : {};
        this.isSearch = false;
        this.paymentInfoList = paymentInfo || [];
        let paymentChannelNo = '';
        let paymentChannelName = '';
        let channelNo = '';
        let payeeBusinessNos = '';
        let flag = false;
        let list = [];
        const { type, payeeBusinessNo, paymentTotalAmount, payAmount, refundAmount } = this.paymentObj;
        // 选择默认的服务商
        if (payeeBusinessNo) {
          const defaultList = paymentInfo.filter((it) => it.payeeBusinessNo === payeeBusinessNo);
          if (defaultList.length) {
            this.defaultPayeeBusinessList = defaultList || [];
            list = defaultList || [];
          } else {
            this.defaultPayeeBusinessList = [];
            // 服务费付款单 不能代付
            if (type === 4) {
              flag = true;
            }
            // 取第一个渠道选中
            list = paymentInfo.slice(0, 1) || [];
          }
        } else {
          this.defaultPayeeBusinessList = [];
          // 服务费付款单 不能代付
          if (type === 4) {
            flag = true;
          }
          // 取第一个渠道选中
          list = paymentInfo.slice(0, 1) || [];
        }
        if (flag) {
          paymentChannelNo = '';
          paymentChannelName = '';
          channelNo = '';
          payeeBusinessNos = '';
          list.forEach((it) => {
            it.disabled = true;
          });
        } else {
          paymentChannelNo = list.length ? list[0].paymentChannelNo : '';
          paymentChannelName = list.length ? list[0].paymentChannelName : '';
          channelNo = list.length ? list[0].channelNo : '';
          payeeBusinessNos = list.length ? list[0].payeeBusinessNo : '';
          if (list.length) {
            const payFlag = this.payCodeType === '1' && (list[0].usableAmount <= paymentTotalAmount || list[0].usableAmount <= payAmount);
            const payFlag2 = this.payCodeType === '2' && list[0].usableAmount <= refundAmount;
            if (payFlag || payFlag2) {
              paymentChannelNo = '';
              paymentChannelName = '';
              channelNo = '';
              payeeBusinessNos = '';
            }
          }
        }
        this.searchPaymentInfoList = list;
        this.paymentChannelNo = paymentChannelNo || '';
        this.$emit('channelCodeChange', { channelCode: val, paymentChannelNo, paymentChannelName, payeeBusinessNo: payeeBusinessNos, channelNo });
      });
    },
    // 模糊搜索对应的服务商
    searchValChange() {
      const reg = new RegExp(this.searchVal);
      const list = [];
      this.paymentInfoList.forEach((el) => {
        if (reg.test(el.paymentChannelNo) || reg.test(el.paymentChannelName)) {
          list.push(el);
        }
      });
      this.searchPaymentInfoList = list;
    },
    // 选择其他付款方式渠道
    selectOther() {
      this.isSearch = true;
      const list = (this.paymentInfoList || []).filter((it) => it.payeeBusinessNo !== this.paymentObj.payeeBusinessNo);
      if (this.paymentObj.type === 4) {
        list.forEach((el) => {
          el.disabled = true;
        });
      }
      this.searchPaymentInfoList = [...this.defaultPayeeBusinessList, ...list];
    },
    // 获取验证码
    async getVaildPaySellerSmsCode() {
      try {
        this.timeStr = 60;
        this.timer = window.setInterval(() => {
          this.timeStr -= 1;
          // 请求页面
          if (this.timeStr < 1) {
            this.clearInterval();
          }
        }, 1000);

        if (this.isSmsFlag) {
          return;
        }
        this.isSmsFlag = true; // 防止重复提交
        const paramObj = {
          paymentReqId: this.payMethodObj.paymentReqId,
        };
        let res = null;
        if (this.payCodeType === '2') {
          res = await getRefundSendPayCode(paramObj);
        } else {
          res = await setPaymentPaymentSendPayCode(paramObj);
        }
        this.$message.success(res.message || '短信发送成功！');
      } catch (error) {
        console.log(error);
        this.clearInterval();
      } finally {
        this.isSmsFlag = false;
      }
    },
    setRadioDisabled(row) {
      if (this.payCodeType === '2') {
        return row.usableAmount < this.paymentObj.refundAmount || row.disabled;
      }
      return row.usableAmount < this.paymentObj.paymentTotalAmount || row.usableAmount < this.paymentObj.payAmount || row.disabled;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-radio-group {
    .is-active {
      .icon-svg {
        color: #fff;
      }
    }
    .icon-svg {
      color: $color-primary;
    }
  }
  .group-list {
    width: 100%;
    max-height: 150px;
    overflow-y: scroll;
    .el-radio__label {
      flex: 1;
    }
  }
  .channel-code {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}

.main-cont-item {
  padding-bottom: 16px;
  margin-bottom: 0;
  h2 {
    font-size: 14px;
  }
  &:last-child {
    padding-bottom: 0px;
  }
}

.payment-code-tip {
  .payment-code-tip-num {
    color: #ffc02a;
    font-weight: bold;
    font-size: 14px;
  }
  white-space: nowrap;
  font-size: 12px;
}

.text-btn {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #828487;
  line-height: 18px;
  padding-left: 0 !important;
}

.search-box {
  width: 293px;
  margin-bottom: 20px;
}
</style>
